<template>
  <component v-if="_config" :is="temp" />
</template>

<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
import PageLayout from '@c/layout/PageLayout'
export default {
  mixins: [appConfigMixins],
  components: {
    PageLayout,
    nox: () => import('@t/xuanfei/nox')
  },
  data() {
    return {}
  },
  computed: {
    temp() {
      try {
        return this._config.app_config.configValue.template.xuanfei || 'nox'
      } catch {
        return 'nox'
      }
    }
  }
}
</script>

<style scoped>
</style>